export const apiEnv = () => {
    switch(location.host) {
        //  == DEVELOPMENT ==
        case 'localhost:8080':
        case 'localhost:8081':
            var apiPath = 'http://localhost:8000/api';
            break;
        //  == STAGING ==
        case 'stg-2018-tiff.kray.jp':
            var apiPath = 'http://stg-api-2018-tiff.kray.jp/api';
            break;
        //  == PRODUCTION ==
        default:
            var apiPath = 'https://api-2018.tiff-jp.net/api';
            break;
    }
    return apiPath;
}
export const ticketEnv = () => {
    switch(location.host) {
        //  == DEVELOPMENT ==
        case 'localhost:8080':
        case 'localhost:8081':
            var ticketPath = 'https://dev4entry31st.azurewebsites.net';
            break;
        //  == STAGING ==
        case 'stg-2018-tiff.kray.jp':
            var ticketPath = 'https://dev4entry31st.azurewebsites.net';
            break;
        //  == PRODUCTION ==
        default:
            var ticketPath = 'http://entry31st.tiff-ticket.net';
            break;
    }
    return ticketPath;
}



// WEBPACK FOOTER //
// ./src/env.js